export const AVATAR_UPDATED_EVENT = 'chio:avatar-updated';

export function validateAvatar(file: File): string | null {
    const types = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
    // Some Android document providers omit MIME. The server validates bytes.
    const unknownType = !file.type || file.type === 'application/octet-stream';
    if (!types.includes(file.type.toLowerCase()) && !(unknownType && /\.(jpe?g|png|webp|heic|heif)$/i.test(file.name))) {
        return 'Поддерживаются JPG, PNG, WEBP, HEIC.';
    }
    if (file.size > 5 * 1024 * 1024) return 'Размер до 5 МБ.';
    if (!file.size) return 'Выбранный файл пуст.';
    return null;
}

export function avatarUrlFromResponse(data: any): string {
    if (data && data.exists === false) return '';
    return (data && (data.avatarAbsoluteUrl || data.avatarUrl)) || '';
}

export function notifyAvatarUpdated(url: string): void {
    window.dispatchEvent(new CustomEvent(AVATAR_UPDATED_EVENT, { detail: { url } }));
}

export function avatarErrorMessage(error: any): string {
    const code = error && error.response && error.response.data && error.response.data.error;
    const errors: { [key: string]: string } = {
        file_too_large: 'Размер до 5 МБ.',
        unsupported_type: 'Поддерживаются JPG, PNG, WEBP, HEIC.',
        invalid_image: 'Не удалось прочитать фото. Выберите другой снимок.',
        invalid_upload: 'Файл загрузился не полностью. Повторите загрузку.',
        image_dimensions_too_large: 'Фото слишком большое. Выберите снимок до 24 мегапикселей.',
        heic_decoder_unavailable: 'Обработка HEIC временно недоступна. Выберите JPG или PNG.',
        avatar_storage_unavailable: 'Хранилище фото временно недоступно. Попробуйте позже.',
        unauthorized: 'Не удалось подтвердить вход. Войдите снова и повторите загрузку.',
    };
    return errors[code] || 'Не удалось сохранить фото. Повторите попытку.';
}
